import OrderDTO from "@/dto/order/OrderDTO";
import LogisticsCompanyNameMap from "@/map/LogisticsCompanyNameMap";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { getRealOrderOriginalId } from "@/utils/OrderUtils";
import { Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

interface LogisticsRecommendColumnProps {
    order: OrderDTO;
}

const LogisticsRecommendColumn: React.FC<LogisticsRecommendColumnProps> = function (props) {
    const { order } = props;
    const orderOriginalId = getRealOrderOriginalId(order);
    const { storage } = useOrderManagementStore();

    const res = storage.ksLogisticsRecommendMapping.get(orderOriginalId);

    if (!res?.length) return <td></td>;

    return (
        <td>
            {res.map((res, index) => {
                if (!res) return null;
                if (!res.reachable) return null;
                if (!res.logisticsCompany || !res.recommendReason) return null;

                return (
                    <p key={res.logisticsCompany} style={{ margin: "2px 0" }}>
                        <Tooltip title={res.recommendReason}>
                            <span>
                                {index + 1}.{LogisticsCompanyNameMap[res.logisticsCompany]}
                            </span>
                        </Tooltip>
                    </p>
                );
            })}
        </td>
    );
};

export default observer(LogisticsRecommendColumn);
